import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { useEffect } from 'react';
import Loading from '../../../../components/Shared/Loader/Loading';
import NoData from '../../../../components/NoData/NoData';
import { getMyEquipmentsList } from '../../../../store/FLEET/Equipments/equipmentsSlice';
import NtxTable from '../../../../components/DataTable/NtxTable';

const MyVehicles = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { MyEquipmentsList, errorById, loadingById } = useAppSelector((s) => s.Equipments);

  useEffect(() => {
    dispatch(getMyEquipmentsList());
  }, []);
  // console.log(MyEquipmentsList);

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Plate_Number'), key: 'Plate_Number' },
    // { title: t('AssetNumber'), key: 'AssetNumber' },
   ];

  const tableData = MyEquipmentsList?.map((item) => {
    let rowClass;

    return {
      Name: (
        <div className="d-flex align-items-center">
          <div className="w-50px h-50px bg-white bg-opacity-25 d-flex align-items-center justify-content-center">
            {item.image === null ? (
              <img alt="" className="mw-100 mh-100" src="/assets/img/Image/NoImg2.ico" />
            ) : (
              <img
                alt=""
                className="mw-100 mh-100" //img-fluid
                src={item?.image?.filePath}
              />
            )}
          </div>
          <div className="ms-3">{i18n.language === 'en' ? item.name : item.name2}</div>
        </div>
      ),
      Plate_Number: item.plateNo,
      AssetNumber: item.code,
     

      rowClass, // استخدم rowClass هنا
    };
  });

  return (
    <div className="p-2">
      <Loading loading={loadingById} error={errorById} Type="Dots">
        <NtxTable
          data={tableData || []}
          columns={columns}
          dataPerPage={4}
          theadClass=""
          tableClass="table text-nowrap table-hover "
          // enableSearch
          // showRecordsSelector
        />
      </Loading>
    </div>
  );
};

export default MyVehicles;
